import { useQuery } from "@apollo/client";
import { GridInputs } from "../../../../../components/Functional";
import { FETCH_CURRENCIES } from "../../../../../graphql/query/Currency";
import { FETCH_VALUE_TYPES } from "../../../../../graphql/query/ValueType";

const History = props => {
  const { formik } = props || {};
  const { data: { currencies = [] } = {} } = useQuery(FETCH_CURRENCIES);
  const { data: { valueTypes = [] } = {} } = useQuery(FETCH_VALUE_TYPES);

  // Check if a valuation type is selected to show valuation range fields
  const hasValueType = formik?.values?._value?.typeId;

  const inputs = {
    className: `grid ${hasValueType ? "grid-cols-4" : "grid-cols-3"} gap-16 mt-5`,
    inputs: [
      // Column 1: Type & Currency
      {
        className: "flex flex-col gap-4",
        inputs: [
          {
            label: "Type",
            name: "_value.typeId",
            type: "multi-select",
            isMulti: false,
            options: valueTypes?.map(item => ({
              label: item.description,
              value: item.id,
            })),
          },
          {
            name: "_value.currencyId",
            type: "multi-select",
            label: "Currency",
            isMulti: false,
            options: currencies?.map(currency => ({
              label: `${currency.description} (${currency.code})`,
              value: currency.id,
            })),
          },
        ],
      },
      // Column 2: Valuation Range (conditional)
      ...(hasValueType
        ? [
            {
              className: "flex flex-col gap-4",
              inputs: [
                {
                  label: "Valuation From",
                  name: "_value.value.value.from",
                  hasOperator: false,
                  type: "number",
                  step: "0.01",
                  placeholder: "0.00",
                },
                {
                  label: "Valuation To",
                  name: "_value.value.value.to",
                  hasOperator: false,
                  type: "number",
                  step: "0.01",
                  placeholder: "0.00",
                },
              ],
            },
          ]
        : []),
      // Column 3: Date Range
      {
        className: "gap-4",
        inputs: [
          {
            label: "From",
            name: "_value.date.value.from",
            type: "date",
          },
          {
            label: "To",
            name: "_value.date.value.to",
            type: "date",
          },
        ],
      },
      // Column 4: Sales Strategy & Returns
      {
        className: "gap-4",
        inputs: [
          {
            label: "Sales Strategy",
            name: "salesStrategy",
            type: "text",
          },
          {
            designType: "threeStateCheckbox",
            label: "Return",
            name: "returns",
            type: "toggle",
          },
          {
            designType: "threeStateCheckbox",
            label: "Director Confirm (Return)",
            name: "returnsDirector",
            type: "toggle",
          },
        ],
      },
    ],
  };

  const gridInputProps = {
    formik,
    ...inputs,
  };

  return <GridInputs {...gridInputProps} />;
};

export default History;
